import React, { useEffect } from 'react';
import AppRoutes from './AppRoutes';
// import { Logo } from './Logo'; 
function App() {
  useEffect(() => {
    // Esta função registra o Service Worker que cuidará das notificações push
    // const registerServiceWorker = () => {
    //   if ('serviceWorker' in navigator) {
    //     window.addEventListener('load', () => {
    //       navigator.serviceWorker.register('/service-worker.js')
    //         .then(registration => {
    //           console.log('Service Worker registrado com sucesso:', registration);
    //         })
    //         .catch(error => {
    //           console.error('Falha ao registrar Service Worker:', error);
    //         });
    //     });
    //   }
    // };

    // registerServiceWorker();

  }, []);

  return (
    <div className="app">
      {/* AppRoutes conterá o ChakraProvider e todas as rotas */}
      <AppRoutes />
    </div>
  );
}

export default App;